<div class="row m-0 pt-2">
  <div class="col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label for="inputtext-right">CPF/CNPJ</mat-label>
      <input
        type="text"
        id="inputtext-right"
        matInput
        [formControl]="form.get('cpf_cnpj')"
        [mask]="'000.000.000-00||00.000.000/0000-00'"
        (blur)="checkCpfCnpj()"
      />
      <i
        matSuffix
        class="pi pi-spin pi-spinner text-primary mr-3"
        *ngIf="loadingParceiro"
      ></i>
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('repeated')">
      {{ messages.cpf_cnpj.repeated }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('required')">
      {{ messages.cpf_cnpj.required }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('pattern')">
      {{ messages.cpf_cnpj.pattern }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('duplicate')">
      {{ messages.cpf_cnpj.duplicate }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('maxlength')">
      {{ messages.cpf_cnpj.maxlength }}
    </small>
    <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('validateCPF')">
      {{ messages.cpf_cnpj.validateCPF }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('cpf_cnpj').hasError('validateCNPJ')"
    >
      {{ messages.cpf_cnpj.validateCNPJ }}
    </small>
  </div>
  <div class="col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Nome/razão social </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('nome_razao_social')"
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('required')"
    >
      {{ messages.nome_razao_social.required }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('maxlength')"
    >
      {{ messages.nome_razao_social.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('minlength')"
    >
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('isEmptyValue')"
    >
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>
  <div class="col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Apelido/nome fantasia</mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('apelido_nome_fantasia')"
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('required')"
    >
      {{ messages.apelido_nome_fantasia.required }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('maxlength')"
    >
      {{ messages.apelido_nome_fantasia.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('minlength')"
    >
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('isEmptyValue')"
    >
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>
  <div class="col-md-4 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Inscrição estadual/RG</mat-label>
      <input
        matInput
        type="text"
        (keydown)="notText($event)"
        (blur)="checkRgInscEstadual()"
        [formControl]="form.get('rg_insc_est')"
      />
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('pattern')">
      {{ messages.rg_insc_est.pattern }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('maxlength')"
    >
      {{ messages.rg_insc_est.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('duplicate')"
    >
      {{ messages.rg_insc_est.duplicate }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
    >
      {{ messages.rg_insc_est.existSpecialChar }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
    >
      {{ messages.rg_insc_est.isEmptyValue }}
    </small>
  </div>
  <div class="col-md-4 mt-3">
    <mat-form-field appearance="outline" color="primary" class="width-100">
      <mat-label>Data de nascimento</mat-label>
      <input
        [id]="ID_FIELD_DTNASC"
        matInput
        appFormatData
        (focus)="onFocus($event, true)"
        (blur)="focusElement === ID_DTPICKER_NASC ? null : onFocus(null, false)"
        [formControl]="form.get('data_nascimento')"
        [matDatepicker]="dataPicker"
      />
      <mat-datepicker-toggle
        *ngIf="
          inputElementDtNasc
            ? inputElementDtNasc
            : !form.get('data_nascimento').value
            ? focusElement === ID_FIELD_DTNASC ||
              focusElement === ID_DTPICKER_NASC
            : focusElement === ID_FIELD_DTNASC ||
              form.get('data_nascimento').value
        "
        (click)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseover)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseout)="onFocus(null)"
        matSuffix
        [for]="dataPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker
        #dataPicker
        color="primary"
        (closed)="onFocus(null, false)"
      ></mat-datepicker>
    </mat-form-field>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('matDatepickerParse')"
    >
      Esta data é invalida.
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('invalidDate')"
    >
      Data não pode ser posterior a atual
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('isEmptyValue')"
    >
      Valor inválido remova os espaços em branco
    </small>
  </div>
  <div class="col-md-4 mt-3">
    <mat-form-field appearance="outline" class="width-100">
      <mat-label>Tipo de vendedor</mat-label>
      <mat-select [formControl]="form.controls.tipo">
        <mat-option *ngFor="let i of tipoVendedor" [value]="i.value">
          {{ i.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="form.get('tipo').touched && form.get('tipo').hasError('required')"
    >
      Um tipo de vendedor é obrigatório
    </small>
  </div>
  <autocomplete-users
    #input
    [autoFirst]="false"
    class="col-md-12 mt-3"
    required
    [notShowResultsFirst]="false"
    [control]="form.get('user')"
    (clearSelection)="form.get('user').reset()"
    [controlIsEnabled]="form.get('user').enabled"
    [user_id]="user_id"
    placeholder="Usuário"
    [domain_id]="tokenService.getDomain().id"
    aria-autocomplete="off"
    displayField="name"
    [messages]="{
      typeIs: 'Informe um valor inválido'
    }"
    [pageValue]="'0'"
    [pageSizeValue]="'10'"
  ></autocomplete-users>
</div>
